import { useEffect, useState } from "react";
import { listCity, listDistrict } from "../../providers/ikas";

export default function CityAndDistrict({
  city,
  setCity,
  district,
  setDistrict,
  selectPage,
  setSelectPage,
}) {
  const [filterCity, setFilterCity] = useState("");
  const [filterDistrict, setFilterDistrict] = useState("");
  const [cities, setCities] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [loading, setLoading] = useState(false);

  const getCities = async () => {
    setLoading(true);
    try {
      //TR State Id
      //dcb9135c-4b84-4c06-9a42-f359317a9b78
      const cities = await listCity("dcb9135c-4b84-4c06-9a42-f359317a9b78");
      setCities(cities);
    } finally {
      setLoading(false);
    }
  };
  const getDistricts = async () => {
    setLoading(true);
    try {
      const districts = await listDistrict(city.id);
      setDistricts(districts);
    } finally {
      setLoading(false);
    }
  };

  const handleCityChange = (e) => setFilterCity(e.target.value);
  const handleDistrictChange = (e) => setFilterDistrict(e.target.value);
  const handleCitySelect = (cityName) => {
    setCity(cityName);
    setFilterDistrict("");
    if (setSelectPage) setSelectPage("district");
  };
  const handleDistrictSelect = (districtName) => {
    setDistrict(districtName);
    if (setSelectPage) setSelectPage("address");
  };
  useEffect(() => {
    getCities();
  }, []);
  useEffect(() => {
    if (city?.id) {
      getDistricts();
    }
  }, [city]);

  return (
    <div className="w-full max-w-sm min-w-[200px] flex flex-col gap-4 p-2 mx-auto pb-24">
      {loading && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center transition-opacity duration-200">
          <span className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></span>
        </div>
      )}
      {selectPage === "city" && (
        <>
          <div className="relative">
            <input
              value={filterCity}
              onChange={handleCityChange}
              type="text"
              className="w-full p-2 py-2 bg-transparent placeholder:text-gray-400 text-black text-lg border border-gray-300 rounded-md transition duration-300 ease focus:outline-none focus:border-gray-400 hover:border-gray-400 shadow-sm focus:shadow"
              placeholder="Şehir Ara..."
            />
          </div>
          <div className="border rounded-md bg-white shadow-sm">
            {cities
              .filter((c) =>
                c.name.toLowerCase().includes(filterCity.toLowerCase())
              )
              .map((city, index) => (
                <div
                  key={index}
                  className="py-3 px-4 cursor-pointer hover:bg-gray-50 border-b last:border-b-0"
                  onClick={() => handleCitySelect(city)}
                >
                  <h2 className="text-base font-medium text-gray-800">
                    {city.name}
                  </h2>
                </div>
              ))}
          </div>
        </>
      )}
      {selectPage === "district" && city?.id && (
        <>
          <div className="relative">
            <input
              value={filterDistrict}
              onChange={handleDistrictChange}
              type="text"
              className="w-full p-2 py-2 bg-transparent placeholder:text-gray-400 text-black text-lg border border-gray-300 rounded-md transition duration-300 ease focus:outline-none focus:border-gray-400 hover:border-gray-400 shadow-sm focus:shadow"
              placeholder="İlçe Ara..."
            />
          </div>
          <div className="border rounded-md bg-white shadow-sm">
            {districts
              .filter((d) =>
                d.name.toLowerCase().includes(filterDistrict.toLowerCase())
              )
              .map((district, index) => (
                <div
                  key={index}
                  className="py-3 px-4 cursor-pointer hover:bg-gray-50 border-b last:border-b-0"
                  onClick={() => handleDistrictSelect(district)}
                >
                  <h2 className="text-base font-medium text-gray-800">
                    {district.name}
                  </h2>
                </div>
              ))}
          </div>
        </>
      )}
    </div>
  );
}
